<div>
    <ng-container
        *ngIf="detailedOutBalance; else outStandingBalTemp">
        <div class="bn-outstanding-bal mb-2">
            <div class="bn-bal-carret d-flex" (click)="isMobile && outstandingBalTooltipContent && toggleTooltip($event, outstandingBalTooltip)">
                <div>
                  {{ 'OUTSTANDING_BALANCE' | translate}}*
                </div>
                <div *ngIf="outstandingBalTooltipContent" class="ml-1">
                    <app-info-tooltip
                        #outstandingBalTooltip
                        [content]="outstandingBalTooltipContent"
                        [align]="'left'"
                        [position]="'bottom'">
                    </app-info-tooltip>
                </div>
            </div>

            <ng-container *ngIf="isAcmic; else maCarretIcons">
                <ng-container *ngIf="!showRenewalAndCurrentBalance; else upArrow">
                    <img src="./assets/img/images/bn-arrow-down-acmic.svg" class="cursor-pointer"
                        alt="down arrow icon" (click)="viewOutStandingBalance(true)" />
                </ng-container>
                <ng-template #upArrow>
                    <img src="./assets/img/images/bn-arrow-up-acmic.svg" class="cursor-pointer"
                        alt="up arrow icon" (click)="viewOutStandingBalance(false)" />
                </ng-template>
            </ng-container>
            <ng-template #maCarretIcons>
                <ng-container *ngIf="!showRenewalAndCurrentBalance; else upArrow">
                    <img src="./assets/img/images/bn-arrow-down-red.svg" class="cursor-pointer"
                        alt="down arrow icon" (click)="viewOutStandingBalance(true)" />
                </ng-container>
                <ng-template #upArrow>
                    <img src="./assets/img/images/bn-arrow-up-red.svg" class="cursor-pointer"
                        alt="up arrow icon" (click)="viewOutStandingBalance(false)" />
                </ng-template>
            </ng-template>
        </div>
    </ng-container>
    <ng-template #outStandingBalTemp>
        <div class="bn-title-text mb-2" [ngClass]="{'bn-title-text-acmic':isAcmic}">                
            <div class="d-flex" (click)="isMobile && outstandingBalTooltipContent && toggleTooltip($event, outstandingBalTooltip)">
                <div>
                  {{ 'OUTSTANDING_BALANCE' | translate}}*
                </div>
                <div *ngIf="outstandingBalTooltipContent" class="ml-1">
                    <app-info-tooltip
                        #outstandingBalTooltip
                        [content]="outstandingBalTooltipContent"
                        [align]="'left'"
                        [position]="'bottom'">
                    </app-info-tooltip>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-container
        *ngIf="!policy?.billingDetails[0] || (policy?.billingDetails[0] && outstandingBalance === 0)">
        <div class="bn-title-val"
            [ngClass]="{'margin-bottom mb0':showRenewalAndCurrentBalance, 'bn-title-val-acmic':isAcmic, 'corprate-color': !isAcmic && detailedOutBalance}">
            $0.00</div>
    </ng-container>
    <ng-container
        *ngIf="policy?.billingDetails[0] && policy?.billingDetails[0]?.outstandingbalance !== 0 && policy?.policynumber?.policyNumber?.length === 6">
        <div class="bn-title-val"
            [ngClass]="{'margin-bottom mb0':showRenewalAndCurrentBalance, 'bn-title-val-acmic':isAcmic}">{{
            policy?.billingDetails[0]?.outstandingbalance | currency }}</div>
    </ng-container>
    <ng-container *ngIf="policy?.policynumber?.policyNumber?.length > 6 && outstandingBalance > 0">
        <div class="bn-title-val"
            [ngClass]="{'margin-bottom mb0':showRenewalAndCurrentBalance, 'bn-title-val-acmic':isAcmic, 'corprate-color': !isAcmic && detailedOutBalance}"
        >{{ outstandingBalance | currency }}</div>
    </ng-container>
    <ng-container *ngIf="showRenewalAndCurrentBalance">
        <div class="bn-renewal-current-balance">
            <hr class="thin-hr mb-2 mt-2">
            <div class="bn-renewal-current-balance-in">
                <ng-container *ngIf="policy?.isUnderRenewal && policy.billingDetails[0] && priorTermBalance !== 0">
                    <div class="bn-term-bal mb-2" [ngClass]="{'mb-3': isAcmic}">
                        <div class="mb-2 bn-title-text bn-term-balance" [ngClass]="{'bn-title-text-acmic':isAcmic}">
                            Renewal term balance
                        </div>
                        <div class="bn-term-val">
                            {{ policy?.billingDetails[0]?.outstandingbalance | currency }}
                        </div>
                    </div>
                    <div class="bn-term-bal">
                        <div class="mb-2 bn-title-text bn-term-balance" [ngClass]="{'bn-title-text-acmic':isAcmic}">
                            Current term remaining balance
                        </div>
                        <div class="bn-term-val">{{ priorTermBalance | currency }}</div>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="!policy?.isUnderRenewal && policy.hasPriorYearBalance && policy.billingDetails[0]">
                    <div class="bn-term-bal mb-2" [ngClass]="{'mb-3': isAcmic}">
                        <div class="mb-2 bn-title-text bn-term-balance" [ngClass]="{'bn-title-text-acmic':isAcmic}">
                            Current term remaining balance
                        </div>
                        <div class="bn-term-val">{{ policy?.billingDetails[0]?.outstandingbalance | currency
                            }}</div>
                    </div>
                    <div class="bn-term-bal">
                        <div class="mb-2 bn-title-text bn-term-balance" [ngClass]="{'bn-title-text-acmic':isAcmic}">
                            Prior term remaining balance
                        </div>
                        <div class="bn-term-val">{{ priorTermBalance | currency }}</div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</div>
